"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _menu = require("../utils/menu");
var _logger = _interopRequireDefault(require("../utils/logger"));
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); } /* eslint-disable no-underscore-dangle */
/**
 * 无极组件的模块类
 */
var _compInfo = /*#__PURE__*/new WeakMap();
var Module = /*#__PURE__*/function () {
  function Module(compKey, baseComp, allWebpackExternals) {
    (0, _classCallCheck2["default"])(this, Module);
    _classPrivateFieldInitSpec(this, _compInfo, undefined);
    this.compKey = compKey;
    // 基类：业务上需要组件加载器内帮忙判断并继承组件的基类
    this.baseComp = baseComp;
    this.status = _menu.ModuleStatus.INIT;
    this.errorStatus = _menu.ErrorStatus.NONE;
    this.error = null;
    // 对应的无极组件商店信息
    this.compsDB = null;
    // 组件的依赖(线上的无极组件)
    this.compDependencies = [];
    // 公共的所有外部依赖（所有的 -- 组件加载器级别的公共存储）
    this.allWebpackExternals = allWebpackExternals;
    // 公共的外部依赖 -- webpack externals
    this.webpackExternals = [];
    // 待执行函数
    this.compFunc = null;
    // 组件发起下载的promise
    this.loadPromise = null;
    // 是否hmr的组件
    this.isHmr = false;
    // 是否是懒加载组件
    this.lazyLoad = false;
  }
  return (0, _createClass2["default"])(Module, [{
    key: "setErrorStatus",
    value:
    /**
     * 设置组件模块的异常状态
     * @param {*} status
     */
    function setErrorStatus() {
      var errorStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _menu.ErrorStatus.NONE;
      if (this.status === _menu.ModuleStatus.COMPLETE) {
        // 已被设置过，就不要重复了；保留错误状态
        return;
      }
      this.errorStatus = errorStatus;
      this.status = _menu.ModuleStatus.COMPLETE;
    }

    /**
     * 获取组件实例
     */
  }, {
    key: "compInfo",
    get: function get() {
      if (!_classPrivateFieldGet(_compInfo, this)) {
        try {
          // 如果组件实例还不存在，则通过懒执行的组件函数compFunc进行实例化
          var externalDeps = this.getExternalDeps();

          // 如果是懒加载模块，我们只能拿到它的配置信息
          if (this.lazyLoad) {
            _classPrivateFieldSet(_compInfo, this, this.getLazyLoadCompInfo(externalDeps));
          } else {
            _classPrivateFieldSet(_compInfo, this, this.getComponentInfo(externalDeps));
          }
          this.setErrorStatus();
        } catch (e) {
          this.setErrorStatus(_menu.ErrorStatus.LOAD_FAIL);
          this.error = e;
          _logger["default"].error("%c wujiComp component[".concat(this.compKey, "] instantiation failed!"), 'color: red;', e);
        }
      }
      return _classPrivateFieldGet(_compInfo, this);
    }

    /**
     * 获取组件的外部依赖
     * @returns 外部依赖实例数组
     */
  }, {
    key: "getExternalDeps",
    value: function getExternalDeps() {
      var _this = this;
      var result = [];
      this.webpackExternals.forEach(function (externalKey) {
        var external = _this.allWebpackExternals[externalKey] || window[externalKey];
        if (!external) {
          throw Error("wujiComp component[".concat(_this.compKey, "] webpackExternals[").concat(externalKey, "] does not exist!"));
        }
        result.push(external);
      });
      return result;
    }

    /**
     * 执行组件的js，获取组件实例以及组件配置信息(config)
     * @param {*} externalDeps 组件需要的外部依赖
     */
  }, {
    key: "getComponentInfo",
    value: function getComponentInfo(externalDeps) {
      var _this$compFunc,
        _this2 = this,
        _this$baseComp,
        _this$baseComp$compIn,
        _this$baseComp$compIn2;
      // 开始实例化
      var compFuncResult = (_this$compFunc = this.compFunc.apply(this, (0, _toConsumableArray2["default"])(externalDeps))) === null || _this$compFunc === void 0 ? void 0 : _this$compFunc["default"];
      var comp = compFuncResult.comp,
        config = compFuncResult.config;

      // 对于非vue2组件，需要通过框架适配器进行包装
      var wrapByFramework = function wrapByFramework(comp, framework) {
        var _this2$allWebpackExte, _this2$allWebpackExte2, _this2$allWebpackExte3, _this2$allWebpackExte4;
        if (!comp || !framework || framework === 'vue') return comp;
        var frameworkLUT = {
          react: (_this2$allWebpackExte = _this2.allWebpackExternals) === null || _this2$allWebpackExte === void 0 ? void 0 : (_this2$allWebpackExte2 = _this2$allWebpackExte.ReactAdaptor) === null || _this2$allWebpackExte2 === void 0 ? void 0 : _this2$allWebpackExte2.ReactInVue,
          vue3: (_this2$allWebpackExte3 = _this2.allWebpackExternals) === null || _this2$allWebpackExte3 === void 0 ? void 0 : (_this2$allWebpackExte4 = _this2$allWebpackExte3.Vue3Adaptor) === null || _this2$allWebpackExte4 === void 0 ? void 0 : _this2$allWebpackExte4["default"]
        };
        return frameworkLUT[framework](comp, config);
      };
      compFuncResult.comp = wrapByFramework(comp, config === null || config === void 0 ? void 0 : config.framework);

      // 业务需求：通过继承基类，则自动帮忙继承schema
      var compExtend = compFuncResult.comp["extends"];
      if (compExtend && compExtend.__uuid__ === ((_this$baseComp = this.baseComp) === null || _this$baseComp === void 0 ? void 0 : (_this$baseComp$compIn = _this$baseComp.compInfo) === null || _this$baseComp$compIn === void 0 ? void 0 : (_this$baseComp$compIn2 = _this$baseComp$compIn.Base) === null || _this$baseComp$compIn2 === void 0 ? void 0 : _this$baseComp$compIn2.__uuid__)) {
        config.propsSchema = this.baseComp.compInfo.mergeBaseSchema(config.propsSchema, config.events);
      }
      if (config !== null && config !== void 0 && config.propPanel) {
        Object.values(config.propPanel).forEach(function (compCfg) {
          if (compCfg.component && compCfg.framework) {
            compCfg.component = wrapByFramework(compCfg.component, compCfg.framework);
          }
        });
      }
      return compFuncResult;
    }

    /**
     * 获取懒加载的compInfo
     * @returns
     */
  }, {
    key: "getLazyLoadCompInfo",
    value: function getLazyLoadCompInfo(externalDeps) {
      var _this$compFunc2;
      var config = (_this$compFunc2 = this.compFunc.apply(this, (0, _toConsumableArray2["default"])(externalDeps))) === null || _this$compFunc2 === void 0 ? void 0 : _this$compFunc2["default"];
      if (config.isFormEditor) {
        config.propsSchema = this.baseComp.compInfo.mergeBaseSchema(config.propsSchema, config.events);
      }
      return {
        config: config
      };
    }

    /**
     * 实例化模块的组件信息
     * @param {*} compDependencies 无极组件的依赖
     * @param {*} webpackExternals 公共的外部依赖 -- webpack externals
     * @param {*} compFunc 懒执行的组件函数
     */
  }, {
    key: "init",
    value: function init(compDependencies, webpackExternals, compFunc) {
      this.compDependencies = compDependencies;
      this.webpackExternals = webpackExternals;
      this.compFunc = compFunc;
      this.status = _menu.ModuleStatus.WAITEXEC;
    }
  }, {
    key: "setCompInfo",
    value: function setCompInfo(compInfo) {
      _classPrivateFieldSet(_compInfo, this, compInfo);
    }
  }]);
}();
var _default = exports["default"] = Module;